// Town Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES, COMMON_SPAWNS } from '../config/room-constants.js';

export const townRoom: Room = {
  name: 'Town',
  background: '/media/club-penguin/town.jpg',
  spawn: COMMON_SPAWNS.BOTTOM_CENTER,
  music: '/media/audio/oomoo.mp3',

  colliders: [
    ...STANDARD_BOUNDARIES,
    // Buildings and obstacles
    { x: 172, y: 22, w: 766, h: 187 },
    { x: 24, y: 23, w: 143, h: 238 },
    { x: 837, y: 205, w: 92, h: 59 },
    { x: 688, y: 216, w: 138, h: 117 },
    { x: 181, y: 212, w: 112, h: 68 },
    { x: 815, y: 428, w: 121, h: 86 },
    { x: 8, y: 338, w: 90, h: 86 },
    { x: 3, y: 385, w: 135, h: 128 },
    { x: 142, y: 417, w: 42, h: 99 },
    { x: 193, y: 465, w: 46, h: 45 },
  ],

  hotspots: [
    {
      id: 'town-to-plaza',
      x: 874,
      y: 271,
      w: 66,
      h: 119,
      action: 'goto',
      target: 'plaza',
      spawn: COMMON_SPAWNS.LEFT_ENTRANCE,
    },
    {
      id: 'town-to-dock',
      x: 37,
      y: 265,
      w: 73,
      h: 76,
      action: 'goto',
      target: 'dock',
      spawn: COMMON_SPAWNS.RIGHT_ENTRANCE,
    },
  ],

  // interactiveElements: [
  //   {
  //     id: 'town-info-button',
  //     x: 450,
  //     y: 350,
  //     w: 200,
  //     h: 30,
  //     type: 'button',
  //     text: 'Town Info',
  //     callback: () => {
  //       // This will be injected by the main game when the room is loaded
  //       console.log('Town info button clicked - callback needs to be injected');
  //     },
  //   },
  // ],
};
